import { SET_CAMPAIGN_STATUS } from 'redux/actionTypes';

const initialState = {
	campaignStatus: {},
};

const CampaignStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CAMPAIGN_STATUS:
			return {
				campaignStatus: action.payload,
			};

		default:
			return state;
	}
};

export default CampaignStatusReducer;
